import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { LoaderService } from '../../../core/services/app-loader/app-loader';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [AsyncPipe],
  template: ` @if (loading$ | async){
    <div
      class="fixed inset-0 bg-black/30 flex items-center justify-center z-[1103]"
    >
      <div
        class="w-12 h-12 border-4 border-gray border-t-primary rounded-full animate-spin"
      ></div>
    </div>
    }`,
  styleUrl: './app-loader.scss',
})
export class AppLoader {
  loading$: Observable<boolean>;
  constructor(private loaderService: LoaderService) {
    this.loading$ = this.loaderService.loading$;
  }
}
